// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"69":"component---src-pages-kk-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"69":"c18a3053ae60df13bbb2","293":"a81a7f95631221d0c5c6","454":"fbba0ee452d2a02c974b"}[chunkId] + ".js";
};